import TokenService from './TokenService';
import ApiService from './ApiService';
import {authRedirectUrl, isLocal} from "../Utils/domainUtils";

const {
  REACT_APP_AUTH_REDIRECT_URL_LOCAL: REDIRECT_URL_LOCAL,
  REACT_APP_AUTH_CLIENT_ID: CLIENT_ID,
  REACT_APP_AUTH_CLIENT_ID_LOCAL: CLIENT_ID_LOCAL,
  REACT_APP_AUTH_URL: AUTH_URL,
  REACT_APP_AUTH_URL_LOCAL: AUTH_URL_LOCAL,
} = process.env;

export default {
  signInAmazon(idToken, accessToken) {
    return new Promise(resolve => {
      TokenService.setToken(idToken, accessToken);
      resolve();
    });
  },
  getTokens(code) {
    const url = (isLocal() ? AUTH_URL_LOCAL : AUTH_URL) + '/token';

    const data = {
      code,
      grant_type: 'authorization_code',
      client_id: isLocal() ? CLIENT_ID_LOCAL : CLIENT_ID,
      redirect_uri: isLocal() ? REDIRECT_URL_LOCAL : authRedirectUrl(),
      code_verifier: TokenService.getChallenge(),
    };

    return ApiService.postToCognito(url, data);
  }
};
